import { state, style, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { Day } from '@enums/days.enum';
import { SchedulesService } from '@services/schedules.service';
import { UiService } from '@services/ui.service';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-schedules',
  templateUrl: './schedules.component.html',
  styleUrls: ['./schedules.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class SchedulesComponent
  extends DatatableBaseComponent
  implements OnInit
{
  schedules: any[];

  isLoading = false;

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = [
    'site',
    'startDayTime',
    'endDayTime',
    'days',
    'holidayGroup',
    'actions',
  ];

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private schedulesSrv: SchedulesService,
    private _usersService: UsersService,
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.getRouteData();
    this.initSub();
  }

  private getRouteData(): void {
    this.route.data.subscribe((data: { schedules: any[] }) => {
      this.schedules = data.schedules;
      this.initTable();
    });
  }

  initSub() {
    this.addSubscription(
      this.schedulesSrv.schedulesListChanged.subscribe((schedules) => {
        this.dataSource.data = schedules || [];
        this.dataSource.sort = this.sort;
        this.onEditFinished();
      }),
    );

    this.addSubscription(
      this._usersService.globalSelectedClientSubject.subscribe(() => {
        this.schedulesSrv.get().subscribe();
      }),
    );
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.schedules);

    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'site':
          return item.site.name;
        default:
          return item[property];
      }
    };

    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'site':
            return currentTerm + data.site.name;
          default:
            return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  showDayText(day: Day): string {
    return 'billing.schedules.days.' + Day[day];
  }

  delete(idSchedule: string) {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer cet horaire ?',
    );

    if (confirmation) {
      this.schedulesSrv.delete(idSchedule).subscribe(() => {
        this.uiSrv.showSnackbar('billing.schedules.list.deleted', true);
      });
    }
  }
}
